import { LibraryService } from '../../../../../api/services/library';
import { ContentVisibility, LibraryAccess } from '../../../../../containers/Onboarding/MembershipQuestions/domain';
import { toast } from 'react-toastify';
import miscUtils from '../../../../../utils/miscUtils';
import { AccessLevels } from '../../../../../containers/channels/channelDetails/domain';
import { setCookieValue } from "../../../../../utils/cookieStorage";
import { setlocalStorageValue } from '../../../../../utils/localStorage';
import { ContentType, isCohortCourse } from '../../../../../containers/Library/Admin/domain';
import { ModeratorPermissions } from '../../../../../containers/teamsContainer/domain';

enum StandAloneActionButtonText {
    BUY = "Buy",
    VIEW = "Access",
    UPGRADE = "Upgrade",
}

const contentIsZeroPriced = (standAloneLibraryItem: any): boolean => {
    return (
      standAloneLibraryItem &&
      standAloneLibraryItem.price &&
      standAloneLibraryItem.price.options &&
      standAloneLibraryItem.price.options.length === 1 &&
      standAloneLibraryItem.price.options[0].amount === "0.00"
    )
  }

export const determineStandAloneButtonText = (userId: any, group: any, standAloneLibraryItem: any): string => {
    if(

      standAloneLibraryItem &&
      standAloneLibraryItem.active_access &&
      standAloneLibraryItem.active_access.expired_at &&
      !(
        miscUtils.isAdmin(group && group.user_membership) ||
        (
          miscUtils.isModerator(group && group.user_membership) &&
          miscUtils.moderatorHasAdditionalPerms(
            group,
            ModeratorPermissions.Library
          )
        )
      )
    ) {
      return 'Expired'
    }

    if(
      standAloneLibraryItem.active_access &&
      !standAloneLibraryItem.active_access.expired_at
    ) {
      return StandAloneActionButtonText.VIEW;
    }

    if (!userId && standAloneLibraryItem.access !== LibraryAccess.PRICED) {
      return StandAloneActionButtonText.VIEW;
    }

  if (standAloneLibraryItem.access === "free" || (group && (
    miscUtils.isAdmin(group.user_membership) ||
    (
      miscUtils.isModerator(group.user_membership) &&
      miscUtils.moderatorHasAdditionalPerms(
        group,
        ModeratorPermissions.Library
      )
    )
  ))) {
      return StandAloneActionButtonText.VIEW;
    }

    if (standAloneLibraryItem.access === "paid") {
      if (
        group && 
        group.user_membership && 
        group.user_membership.active_subscription &&
        group.user_membership.active_subscription.plan &&
        group.user_membership.active_subscription.plan.price !== 0
      ) {
        return StandAloneActionButtonText.VIEW;
      } else {
        return StandAloneActionButtonText.UPGRADE;
      }
    }

    if (standAloneLibraryItem.access === "plan") {
      let memberPlanIsAuthorized: boolean = false;

      standAloneLibraryItem.authorized_plans.forEach((plan: any) => {
        if (
          group &&
          group.user_membership &&
          group.user_membership.active_subscription &&
          plan.id === group.user_membership.active_subscription.plan.id
        ) {
          memberPlanIsAuthorized = true;
        }
      });

      if (memberPlanIsAuthorized) {
        return StandAloneActionButtonText.VIEW;
      } else {
        return StandAloneActionButtonText.UPGRADE;
      }
    }

    if (standAloneLibraryItem.access === "priced") {
      if (standAloneLibraryItem.active_access) {
        return StandAloneActionButtonText.VIEW;
      } 
      if(
        standAloneLibraryItem &&
        standAloneLibraryItem.price
      ) {
        if (userId && standAloneLibraryItem.visibility === ContentVisibility.PUBLIC) {
            return contentIsZeroPriced(standAloneLibraryItem) ? `Access for free` : `${StandAloneActionButtonText.BUY}`;
          }
          if (!standAloneLibraryItem.active_access) {
            return contentIsZeroPriced(standAloneLibraryItem) ? `Access for free` : `${StandAloneActionButtonText.BUY}`;
          } else {
            return StandAloneActionButtonText.VIEW;
          }
      } 
    }

    return StandAloneActionButtonText.VIEW;
};

export const getLibraryRedirectLink = (libraryItemType: ContentType, slug: string) => {
  let redirectLink = `/library/${libraryItemType}/${slug}/gallery`;

  return redirectLink;
}

const accessLibraryContent = (group: any, standAloneLibraryItem: any, libraryItemType: any, history: any) => {
    LibraryService.getInstance()
      .accessLibraryItem(group.id, standAloneLibraryItem.id, {
        type: libraryItemType.slice(0, -1),
      })
      .then(() => {
        return history.push(getLibraryRedirectLink(libraryItemType, standAloneLibraryItem.slug));
      }).catch((error: any) => {
        return toast("Failed to access library content. Please try again later. ", {
          type: 'error',
          autoClose: 2000,
          position: "top-center",
          hideProgressBar: true,
          theme: "light"
        });
      })
  }

export const determineStandAloneButtonAction = (userId: any, group: any, standAloneLibraryItem: any, libraryItemType: any, history: any, openLockScreen: any, fallbackAction?: any) => {
    const { 
    navigateToSinglePricingOptionPage, 
    shouldNavigateToPurchasePage,
   } = determinePurchaseNavigation(group, standAloneLibraryItem, history, 'library', libraryItemType);

  if(determineStandAloneButtonText(userId, group, standAloneLibraryItem) === 'Expired') {
      if(
        standAloneLibraryItem &&
        standAloneLibraryItem.access === "priced"
      ) {
        return history.push(`/library/${libraryItemType}/${standAloneLibraryItem.slug}/purchase`);
      }

      toast('Access expired', {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      return 
    }


    if (!userId) {
          if (
      standAloneLibraryItem &&
      standAloneLibraryItem.access === LibraryAccess.SEGMENT &&
      !(
        miscUtils.isAdmin(group && group.user_membership && group.user_membership) ||
        (
          miscUtils.isModerator(group && group.user_membership) &&
          miscUtils.moderatorHasAdditionalPerms(
            group,
            ModeratorPermissions.Library
          )
        )
      ) &&
      !miscUtils.userIsOnResourseSegment(group.user_membership, standAloneLibraryItem.authorized_segments) &&
      !standAloneLibraryItem.active_access
    ) {
      if (standAloneLibraryItem.lock_screen_active) {
        if (standAloneLibraryItem.lock_screen_default_url && standAloneLibraryItem.lock_screen_type === 'redirect') {
          window.location.assign(standAloneLibraryItem.lock_screen_default_url);
          return;
        }
        openLockScreen();
        return;
      }
      // TODO: price decouple
      if(shouldNavigateToPurchasePage) {
        navigateToSinglePricingOptionPage();
        return;
        }
      return toast("You do not have permission to access this content", {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
    }

      //zero priced
      if (
        determineStandAloneButtonText(userId, group, standAloneLibraryItem) === 'Access for free' &&
        standAloneLibraryItem.access === LibraryAccess.PRICED
      ) {
        if(
          standAloneLibraryItem &&
          standAloneLibraryItem.price &&
          standAloneLibraryItem.price.options &&
          standAloneLibraryItem.price.options.length === 1
        ) {
          return history.push(`/library/${libraryItemType}/${standAloneLibraryItem.slug}/purchase?payment_option=${standAloneLibraryItem.price.options[0].slug}`);
        }
        return history.push(`/library/${libraryItemType}/${standAloneLibraryItem.slug}/purchase`);
      }

      if (determineStandAloneButtonText(userId, group, standAloneLibraryItem).includes(StandAloneActionButtonText.VIEW) &&
        standAloneLibraryItem.access === LibraryAccess.FREE &&
        standAloneLibraryItem.visibility === ContentVisibility.PUBLIC) {
          if(
            group &&
            group.close_signup
          ) {
            history.push("/signup-disabled");
            return;
          }
          localStorage.setItem('post_purchase_redirect_link', getLibraryRedirectLink(libraryItemType, standAloneLibraryItem.slug));
          return history.push("/plan-subscription");
      } else if (!determineStandAloneButtonText(userId, group, standAloneLibraryItem).includes(StandAloneActionButtonText.BUY)) {
        
        if (standAloneLibraryItem.lock_screen_active) {
          if (standAloneLibraryItem.lock_screen_default_url && standAloneLibraryItem.lock_screen_type === 'redirect') {
            window.location.assign(standAloneLibraryItem.lock_screen_default_url);
            return;
          }
            openLockScreen();
            return;
        }

        if (
          standAloneLibraryItem.access === "plan" &&
          standAloneLibraryItem.authorized_plans.filter((plan: any) => !plan.archived_at).length === 0
        ) {
          if(shouldNavigateToPurchasePage) {
            navigateToSinglePricingOptionPage();
            return;
          }
          history.push("/plan-disabled");
          return;
        }

        if (
          standAloneLibraryItem.access === "plan" &&
          standAloneLibraryItem.authorized_plans.filter((plan: any) => !plan.archived_at).length === 1
        ) {
          if(shouldNavigateToPurchasePage) {
            navigateToSinglePricingOptionPage();
            return;
          }
          if(
            group &&
            group.close_signup
          ) {
            history.push("/signup-disabled");
            return;
          }
          if(shouldNavigateToPurchasePage) {
            navigateToSinglePricingOptionPage();
            return;
          }
          history.push(`/plan-subscription/checkout?plan=${standAloneLibraryItem.authorized_plans.filter((plan: any) => !plan.archived_at)[0].uuid}&type=${libraryItemType}&id=${standAloneLibraryItem.slug}`);
          return;
        }

        if (
          standAloneLibraryItem.access === "plan" &&
          standAloneLibraryItem.authorized_plans.filter((plan: any) => !plan.archived_at).length > 1
        ) {
           if(
            group &&
            group.close_signup
          ) {
            // TODO: price decouple
            if(shouldNavigateToPurchasePage) {
              navigateToSinglePricingOptionPage();
              return;
              }
            history.push("/signup-disabled");
            return;
          }

          history.push(`/plan-subscription?type=${libraryItemType}&id=${standAloneLibraryItem.slug}`);
          return;
        }

        if (shouldNavigateToPurchasePage && (standAloneLibraryItem.access === "paid")) {
          history.push(`/plan-subscription?type=${libraryItemType}&id=${standAloneLibraryItem.slug}`);
          return;
        }

         if(
            group &&
            group.close_signup
          ) {
            history.push("/signup-disabled");
            return;
        }
        return history.push("/plan-subscription");
      } else {
        //open details?
        if(fallbackAction) {
          fallbackAction();
        }
      }
    }

    if (
      standAloneLibraryItem &&
      standAloneLibraryItem.access === LibraryAccess.SEGMENT &&
      !(
        miscUtils.isAdmin(group && group.user_membership && group.user_membership) ||
        (
          miscUtils.isModerator(group && group.user_membership) &&
          miscUtils.moderatorHasAdditionalPerms(
            group,
            ModeratorPermissions.Library
          )
        )
      ) &&
      !miscUtils.userIsOnResourseSegment(group.user_membership, standAloneLibraryItem.authorized_segments) &&
      !standAloneLibraryItem.active_access
    ) {
      if (standAloneLibraryItem.lock_screen_active) {
        if (standAloneLibraryItem.lock_screen_default_url && standAloneLibraryItem.lock_screen_type === 'redirect') {
          window.location.assign(standAloneLibraryItem.lock_screen_default_url);
          return;
        }
        openLockScreen();
        return;
      }
      // TODO: price decouple
      if(shouldNavigateToPurchasePage) {
        navigateToSinglePricingOptionPage();
        return;
        }
      return toast("You do not have permission to access this content", {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
    }

    if (
      standAloneLibraryItem &&
      standAloneLibraryItem.access === LibraryAccess.FREE &&
      group && !group.user_membership &&
      !miscUtils.isActiveCommunityMember(group && group.user_membership) &&
      // !(
      //   miscUtils.isAdmin(group && group.user_membership && group.user_membership) ||
      //   (
      //     miscUtils.isModerator(group && group.user_membership) &&
      //     miscUtils.moderatorHasAdditionalPerms(group,ModeratorPermissions.Library)
      //   )
      // ) &&
      !standAloneLibraryItem.active_access &&
      group &&
      !group.close_signup
    ) {
      history.push(`/plan-subscription`);
      return;
    }

    switch (determineStandAloneButtonText(userId, group, standAloneLibraryItem)) {
      case StandAloneActionButtonText.VIEW:
        if (standAloneLibraryItem.active_access) {
          return history.push(getLibraryRedirectLink(libraryItemType, standAloneLibraryItem.slug));
        } else {
          accessLibraryContent(group, standAloneLibraryItem, libraryItemType, history);
        }
        break;
      case StandAloneActionButtonText.UPGRADE:
        if (standAloneLibraryItem.lock_screen_active) {
          if (standAloneLibraryItem.lock_screen_default_url && standAloneLibraryItem.lock_screen_type === 'redirect') {
            window.location.assign(standAloneLibraryItem.lock_screen_default_url);
            return;
          }
            openLockScreen();
            return;
        }

        if (
          standAloneLibraryItem.access === AccessLevels.Plan &&
          standAloneLibraryItem.authorized_plans
          // &&
          // standAloneLibraryItem.authorized_plans.filter((plan: any) => !plan.archived_at && !plan.hidden).length === 0
        ) {

          if (
            standAloneLibraryItem.authorized_plans.filter((plan: any) => !plan.archived_at).length === 1
          ) {
            if(shouldNavigateToPurchasePage) {
                window.location.replace(`/plan-subscription?type=${libraryItemType}&id=${standAloneLibraryItem.slug}`);
                return;
            }
            const eventPlans = standAloneLibraryItem.authorized_plans.filter((plan: any) => !plan.archived_at || plan.hidden)
            window.location.replace(`/plan-subscription/checkout?plan=${eventPlans[0].uuid}&type=${libraryItemType}&id=${standAloneLibraryItem.slug}`);
            return;
          }

          if (
            standAloneLibraryItem.authorized_plans.filter((plan: any) => !plan.archived_at).length === 0
            // TODO: price decouple
            && !shouldNavigateToPurchasePage
          ) {
            window.location.replace("/plan-disabled");
            return;
          }

          if (
            standAloneLibraryItem.authorized_plans.filter((plan: any) => !plan.archived_at).length > 1
          ) {
            if(shouldNavigateToPurchasePage) {
                window.location.replace(`/plan-subscription?type=${libraryItemType}&id=${standAloneLibraryItem.slug}`);
                return;
            }
            window.location.replace(`/plan-subscription?type=${libraryItemType}&id=${standAloneLibraryItem.slug}`);
            return;
          }


        }
        if(shouldNavigateToPurchasePage &&  standAloneLibraryItem.access === "paid") {
            return history.push(`/plan-subscription?type=${libraryItemType}&id=${standAloneLibraryItem.slug}`);
        }
        return history.push("/plan-subscription");
      case 'Access for free':
        if(
          standAloneLibraryItem &&
          standAloneLibraryItem.price &&
          standAloneLibraryItem.price.options &&
          standAloneLibraryItem.price.options.length === 1
        ) {
          return history.push(`/library/${libraryItemType}/${standAloneLibraryItem.slug}/purchase?payment_option=${standAloneLibraryItem.price.options[0].slug}`);
        }
        return history.push(`/library/${libraryItemType}/${standAloneLibraryItem.slug}/purchase`); //zero priced
      default: //default is the purchase case
        if(
          standAloneLibraryItem &&
          standAloneLibraryItem.price &&
          standAloneLibraryItem.price.options &&
          standAloneLibraryItem.price.options.length === 1
        ) {
          return history.push(`/library/${libraryItemType}/${standAloneLibraryItem.slug}/purchase?payment_option=${standAloneLibraryItem.price.options[0].slug}`);
        }
        return history.push(`/library/${libraryItemType}/${standAloneLibraryItem.slug}/purchase`);
    }
};

export const getCourseLessonsCount = (course: any, group: any) => {
  if(
    !course
  ) {
    return 0;
  }
  if(
      group &&
      miscUtils.isTeamMember(group.user_membership)
  ) {
      return course.a_lessons_count;
  }

  return course.lessons_count;
}

export function getCourseButtonActionText(group: any, content: any, userMembership: any) {
  const enrolment = content && content.active_enrolment;

  const showExpiredCTA = () => {
    return (
      content &&
      enrolment &&
      enrolment.expired_at &&
      !miscUtils.isAdmin(userMembership) &&
      !(
        miscUtils.isModerator(userMembership) &&
        miscUtils.moderatorIsAuthorizedForCourse(
          userMembership,
          content
        )
      )
    )
  }
  
  if(
    showExpiredCTA()
  ) {
    return "Expired";
  }

  if (!(enrolment && !(enrolment && enrolment.expired_at)) && content.access === "plan") {

    if(!userMembership) {
      return "Enroll";
    }

    if (
      miscUtils.isAdmin(userMembership) ||
      (
        miscUtils.isModerator(userMembership) &&
        miscUtils.moderatorIsAuthorizedForCourse(
          userMembership,
          content
        )
      )
    ) {
      return "Start";
    }

    if (userMembership && userMembership.active_subscription) {
      const plan = content.authorized_plans.find((plan: any) => {
        return plan.id === userMembership.active_subscription.plan.id;
      });
      return (
          plan || 
          miscUtils.isAdmin(userMembership) 
          ||
          (
            miscUtils.isModerator(userMembership) &&
            miscUtils.moderatorIsAuthorizedForCourse(
              userMembership,
              content
            )
          )
        ) ? "Start" : "Upgrade";
    }

    return "Enroll";
  }

  if(content.access === "paid" && !userMembership && !enrolment) {
    return "Enroll";
  }

  if (content.access === "paid" && (userMembership && !(enrolment && !(enrolment && enrolment.expired_at)) && (!userMembership.active_subscription || userMembership.active_subscription.plan.price === 0) && !(
    miscUtils.isAdmin(userMembership) ||
    (
      miscUtils.isModerator(userMembership) &&
      miscUtils.moderatorIsAuthorizedForCourse(userMembership, content)
    )
  ))) {
    return (userMembership && !userMembership.active_subscription) ? "Enroll" : "Upgrade";
  }

  if (!(enrolment && !(enrolment && enrolment.expired_at)) && content.access !== "priced") {
    if(!userMembership && content.access !== "free") {
      return "Enroll";
    }
    return "Start";
  }

  if (!(enrolment && !(enrolment && enrolment.expired_at)) && content.access === "priced" && !(
    miscUtils.isAdmin(userMembership) ||
    (
      miscUtils.isModerator(userMembership) &&
      miscUtils.moderatorIsAuthorizedForCourse(
        userMembership,
        content
      )
    )
  )) {
    const contentIsZeroPriced = (): boolean => {
      return (
        content &&
        content.price &&
        content.price.option &&
        content.price.option.amount === "0.00"
      );
    }

    return contentIsZeroPriced() ? 'Enroll' : content.price && content.price.option ? `Enroll` : 'Enroll';
  }

  if (!(enrolment && !(enrolment && enrolment.expired_at)) && content.access === "priced" && (
    miscUtils.isAdmin(userMembership) ||
    (
      miscUtils.isModerator(userMembership) &&
      miscUtils.moderatorIsAuthorizedForCourse(
        userMembership,
        content
      )
    )
  )) {
    return "Start";
  }

  let contentsCount = miscUtils.isAdmin(userMembership) ? content.a_lessons_count : content.lessons_count;

  return contentsCount === content.completed_contents_count ? "View" : "Continue";
}

// Whether the course has a price option to buy.
export const coursePriceIsPurchasable = (content: any): boolean => {
  const price = content && content.price;

  return !!price && (
    !!price.option ||
    !!(price.options && price.options.length)
  );
}

export const toastCoursePriceUnset = (): void => {
  toast("The price for this course has not been set yet. Please contact the community admin.", {
    toastId: "course-price-unset",
    type: 'error',
    autoClose: 5000,
    position: "top-center",
    hideProgressBar: true,
    theme: "light"
  });
}

export const navigateToCoursePurchase = (content: any, history: any): void => {
  // A cohort course is priced per cohort, so it has no course price.
  if (!isCohortCourse(content) && !coursePriceIsPurchasable(content)) {
    toastCoursePriceUnset();
    return;
  }

  history.push(`/courses/${content.slug}/purchase`);
}

export const determinePurchaseNavigation = (groupData:any,content: any, history: any, contentType: string, libraryItemType?: string): {
    shouldNavigateToPurchasePage: boolean,
    navigateToSinglePricingOptionPage: () => void,
    publicPriceOptions: any[],
    contentDefaultPriceOptionIsAvailable: boolean,
  } => {
  const communityMember = groupData && miscUtils.isGroupMember(groupData);
  const publicPriceOptions = content && content.price &&
    content.price.options ?
    content.price.options.filter((option: any) => option.active && (communityMember ? (option.show_to === "members" || option.show_to === "public") : option.show_to === "public")) : [];

  const contentDefaultPriceOptionIsAvailable: boolean = content && content.price && content.price.default_option &&
    content.price.default_option.active && (communityMember ? (content.price.default_option.show_to === "members" || content.price.default_option.show_to === "public") : content.price.default_option.show_to === "public");
  
  const shouldNavigateToPurchasePage: boolean = (
      (
        contentDefaultPriceOptionIsAvailable || 
        (publicPriceOptions && publicPriceOptions.length > 0)
      ) &&
      content &&
      content.access &&
      (
        content.access !== "priced" &&
        content.access !== "free"
      )
    )

  const navigateToSinglePricingOptionPage = (): void => {
    if (shouldNavigateToPurchasePage) {
      if(publicPriceOptions && publicPriceOptions.length > 1) {
          history.push(`/${contentType}/${libraryItemType ? `${libraryItemType}/` : ''}${content.slug}/purchase`);
          return;
      }
      if(publicPriceOptions && publicPriceOptions.length === 1) {
          history.push(`/${contentType}/${libraryItemType ? `${libraryItemType}/` : ''}${content.slug}/purchase?payment_option=${publicPriceOptions[0].slug}`);
          return;
      }
        
      if (contentDefaultPriceOptionIsAvailable) {
          history.push(`/${contentType}/${libraryItemType ? `${libraryItemType}/` : ''}${content.slug}/purchase?payment_option=${content.price.default_option.slug}`);
          return;
      }

      history.push(`/${contentType}/${libraryItemType ? `${libraryItemType}/` : ''}${content.slug}/purchase`);
      return;
    }
  }
  
  return { 
    navigateToSinglePricingOptionPage,
    shouldNavigateToPurchasePage,
    publicPriceOptions,
    contentDefaultPriceOptionIsAvailable
  };
}

export function getCourseButtonAction(actionText: string, content: any, history: any, userId: number, userMembership: any, openLockScreen: any, group: any) {
  const enrolment = content && content.active_enrolment;
  const { 
    navigateToSinglePricingOptionPage, 
    shouldNavigateToPurchasePage,
   } = determinePurchaseNavigation(group, content, history, "courses");

  if (
    content &&
    content.access === LibraryAccess.SEGMENT &&
    !miscUtils.isAdmin(userMembership) &&
    !(
      miscUtils.isModerator(userMembership) &&
      miscUtils.moderatorIsAuthorizedForCourse(
        userMembership,
        content
      )
    ) &&
    !miscUtils.userIsOnResourseSegment(userMembership, content.authorized_segments) &&
    (!enrolment || (enrolment && enrolment.expired_at))
  ) {

    if(content.lock_screen_active) {
      if (content.lock_screen_default_url && content.lock_screen_type === 'redirect') {
        window.location.assign(content.lock_screen_default_url);
        return;
      }
      openLockScreen();
      return;
    }
    // TODO: price decouple
    if(shouldNavigateToPurchasePage) {
     navigateToSinglePricingOptionPage();
     return;
    }
    toast("You do not have permission to access this content", {
      type: 'error',
      autoClose: 2000,
      position: "top-center",
      hideProgressBar: true,
      theme: "light"
    });
    return;
  }

    if (
      content &&
      content.access === LibraryAccess.FREE &&
      group && !group.user_membership &&
      !miscUtils.isActiveCommunityMember(group && group.user_membership) &&
      !enrolment &&
      group &&
      !group.close_signup
    ) {
      history.push(`/plan-subscription`);
      return;
    }

  if (!userId) {
    if (content.lock_screen_active) {
      if (content.lock_screen_default_url && content.lock_screen_type === 'redirect') {
        window.location.assign(content.lock_screen_default_url);
        return;
      }
      openLockScreen();
      return;
    }
    if (actionText.startsWith("Enroll")) {
      if (content.access === "paid") {
        setCookieValue("", true);
      }

      if(content.access === "priced") {
        if(
          content &&
          content.price &&
          content.price.options &&
          content.price.options.length === 1
        ) {
          history.push(`/courses/${content.slug}/purchase?payment_option=${content.price.options[0].slug}`);
          return;
        }
        navigateToCoursePurchase(content, history);
        return;
      }
    }

    if (actionText === "Start" && content.access === "free") {
      setlocalStorageValue("next_link", window.location.pathname);
    }

    if (
      content.access === "plan" &&
      content.authorized_plans.filter((plan: any) => !plan.archived_at).length === 0
    ) {
      if (shouldNavigateToPurchasePage) {
         navigateToSinglePricingOptionPage();
        return;
      }
      history.push("/plan-disabled");
      return;
    }

    if (
      content.access === "plan" &&
      content.authorized_plans.filter((plan: any) => !plan.archived_at).length === 1
    ) {
      if(
        group &&
        group.close_signup 
      ) {
        if (shouldNavigateToPurchasePage) {
          navigateToSinglePricingOptionPage();
          return;
        }
        history.push("/signup-disabled");
        return;
      }
        if (shouldNavigateToPurchasePage) {
          history.push(`/plan-subscription?type=courses&id=${content.slug}`);
          return;
        }
      history.push(`/plan-subscription/checkout?plan=${content.authorized_plans.filter((plan: any) => !plan.archived_at)[0].uuid}&type=courses&id=${content.slug}`);
      return;
    }

    if(
      content.access === "plan" &&
      content.authorized_plans.filter((plan: any) => !plan.archived_at).length > 1
    ) {
      if(
        group &&
        group.close_signup
      ) {
        if (shouldNavigateToPurchasePage) {
          navigateToSinglePricingOptionPage();
          return;
        }
        history.push("/signup-disabled");
        return;
      }
      history.push(`/plan-subscription?type=courses&id=${content.slug}`);
      return;
    }

    if (shouldNavigateToPurchasePage && (content.access === "paid")) {
      history.push(`/plan-subscription?type=courses&id=${content.slug}`);
       return;
    }
    if(
      group &&
      group.close_signup
    ) {
      history.push("/signup-disabled");
      return;
    }
    history.push("/plan-subscription");
  }

  if (userId) {
    if(actionText === "Expired" && content.access === "priced") {
      if(
        content &&
        content.price &&
        content.price.options &&
        content.price.options.length === 1
      ) {
        history.push(`/courses/${content.slug}/purchase?payment_option=${content.price.options[0].slug}`);
        return;
      }
      navigateToCoursePurchase(content, history);
      return;
    }
    if(actionText === "Expired") {
      toast('Access expired', {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      return;
    }

    if (actionText === "Start" && (content.access === "free" || content.access === "plan" || content.access === "segment")) {
      miscUtils.startCourse(content, history);
      return;
    }

    if (actionText === "Restart") {
      miscUtils.startCourse(content, history);
      return;
    }

    if ((actionText === "Start" || actionText === "Upgrade" || actionText === "Expired" || actionText === "Enroll") && content.access === "paid" && (!userMembership || !userMembership.active_subscription || userMembership.active_subscription.plan.price === 0) && !(
      miscUtils.isAdmin(userMembership) ||
      (
        miscUtils.isModerator(userMembership) &&
        miscUtils.moderatorIsAuthorizedForCourse(userMembership, content)
      )
    )) {
      if (content.lock_screen_active) {
        if (content.lock_screen_default_url && content.lock_screen_type === 'redirect') {
          window.location.assign(content.lock_screen_default_url);
          return;
        }
        openLockScreen();
        return;
      }
      // TODO: price decouple
      if (shouldNavigateToPurchasePage) {
        history.push(`/plan-subscription?type=courses&id=${content.slug}`);
        return;
      }
      history.push("/plan-subscription");
      return;
    }

    if (actionText === "Start" && content.access === "paid" && ((userMembership && userMembership.active_subscription && userMembership.active_subscription.plan.price > 0) || miscUtils.isAdmin(userMembership) || (
      miscUtils.isModerator(userMembership) &&
      miscUtils.moderatorIsAuthorizedForCourse(userMembership, content)
    ))) {
      miscUtils.startCourse(content, history);
      return;
    }

    if ((actionText.startsWith("Enroll") || actionText === "Expired") && (content.access === "priced")) {
      if(
        content &&
        content.price &&
        content.price.options &&
        content.price.options.length === 1
      ) {
        history.push(`/courses/${content.slug}/purchase?payment_option=${content.price.options[0].slug}`);
        return;
      }
      // TODO: price decouple
      if (shouldNavigateToPurchasePage && (content.access === "plan")) {
        history.push(`/plan-subscription?type=courses&id=${content.slug}`);
        return;
      }
      navigateToCoursePurchase(content, history);
      return;
    }

    if (actionText === "Start" && content.access === "priced") {
      miscUtils.startCourse(content, history);
      return;
    }

    if (actionText === "Upgrade" || (actionText.startsWith("Enroll") && content.access === "plan") || actionText === "Expired") {
      if (content.lock_screen_active) {
        if (content.lock_screen_default_url && content.lock_screen_type === 'redirect') {
          window.location.assign(content.lock_screen_default_url);
          return;
        }
        openLockScreen();
        return;
      }

      if (
        content.access === "plan" &&
        content.authorized_plans &&
        content.authorized_plans.filter((plan: any) => !plan.archived_at).length === 0
      ) {
        if (shouldNavigateToPurchasePage) {
          navigateToSinglePricingOptionPage();
          return;
        }
        window.location.replace("/plan-disabled");
        return;
      }
      if (
        content.access === "plan" &&
        content.authorized_plans &&
        content.authorized_plans.filter((plan: any) => !plan.archived_at).length === 1
      ) {
        if (shouldNavigateToPurchasePage) {
          history.replace(`/plan-subscription?type=courses&id=${content.slug}`);
          return;
        }
        const coursePlans = content.authorized_plans.filter((plan: any) => !plan.archived_at)
        window.location.replace(`/plan-subscription/checkout?plan=${coursePlans[0].uuid}&type=courses&id=${content.slug}`);
        return;
      }

      if (
        content.access === "plan" &&
        content.authorized_plans &&
        content.authorized_plans.filter((plan: any) => !plan.archived_at).length > 1
      ) {
         if (shouldNavigateToPurchasePage) {
          history.replace(`/plan-subscription?type=courses&id=${content.slug}`);
          return;
        }
        window.location.replace(`/plan-subscription?type=courses&id=${content.slug}`);
        return;
      }
      history.push("/plan-subscription");
      return;
    }
  }

  if (actionText === "Continue" || actionText === "View") {
    const lessons = content.lessons || [];
    const lastContent = enrolment && enrolment.last_content;
    const contentId = lastContent && lessons.indexOf(lastContent) > -1 ? lastContent : lessons[0];

    // Without a lesson to open, the course page resolves the cohort's curriculum.
    history.push(
      contentId
        ? `/courses/${content.slug}/lectures/${contentId}`
        : `/courses/${content.slug}`
    );
    return;
  }
}